export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./virtual-sports.vue?vue&type=template&id=5af1a46b"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/virtual-sports/virtual-sports.vue?vue&type=template&id=5af1a46b
// module id = dcFp
// module chunks = 0